import { Injectable } from '@angular/core';
import jsPDF from 'jspdf';
import { DomSanitizer } from '@angular/platform-browser';
import { UserOptions } from 'jspdf-autotable';
import { GlobalService } from '../lib/global.service';
import { iptuFormEnum, itbiFormEnum } from 'src/app/Enums/SpecificFormInputEnum';
import { GenerateDocumentFormService, HeaderForms, IDataTable } from './generate-document-form.service';
import { IItbiDataFormRequest } from 'src/app/interfaces/dataFormRequest';
import { IPdfData } from 'src/app/interfaces/signature-gov.interfaces';
import { getValuesActivity, getValuesGroupActivity } from '../modules/forms/utilities/values-activity';

interface IDataITBIPdf {
	subject: string;
	org: string;
	solicitante: any;
	form: IItbiDataFormRequest;
	description: string;
	usuarioLogado?: any;
}

@Injectable({
	providedIn: 'root',
})
export class DocumentFormService extends GenerateDocumentFormService {

	public listBodyDefault = [
		iptuFormEnum.IPTU_ISENÇÃO_VIÚVAS,
		iptuFormEnum.IPTU_ISENÇÃO_SERVIDOR_PÚBLICO,
		iptuFormEnum.IPTU_ISENÇÃO_LOCADO_NO_MUNICÍPIO,
	]

	public listRequestITBI = [
		itbiFormEnum.ITBI_SOLICITACAO_NÃO_INCIDENCIA,
		itbiFormEnum.ITBI_SOLICITAÇÃO_DE_ISENÇÃO_DE_ITBI
	]

	constructor(
		private sanitizer: DomSanitizer,
		public global: GlobalService,
	) {
		super()
	}

	generatorDocumentFormIptuPDF(data): IPdfData {
		const doc = new jsPDF('p', 'mm', 'a4');

		this.renderHeader(doc);
		this.drawHorizontalLine(38, doc);

		if (this.haveSubject(this.listBodyDefault, data.subject)) {
			this.renderBodyDefaultIptu(doc, data);
		}
		if (data.subject == iptuFormEnum.IPTU_ISENÇÃO_CEDIDO_GRATUITAMENTE) {
			this.renderBodyOrgaoCedido(doc, data);
		}
		if (data.subject == iptuFormEnum.IPTU_ISENÇÃO_SEM_FINS_LUCRATIVOS) {
			this.renderSemFinsLucrativos(doc, data);
		}
		if (data.subject == iptuFormEnum.IPTU_ISENÇÃO_IPTU_DOENÇAS_GRAVES) {
			this.renderBodyIsencaoDoenca(doc, data);
		}
		if (data.subject == iptuFormEnum.IPTU_REQUERIMENTO_DE_IPTU) {
			this.renderBodyRequerimentoIptu(doc, data);
		}
		if (data.subject == iptuFormEnum.IPTU_REQUERIMENTO_IMUNIDADE_DE_IPTU) {
			this.renderBodyRequerimentoImunidade(doc, data);
		}
		this.renderFooter(doc);

		return {
			pdfBase64: doc.output('datauristring').split(',')[1],
			pdfBuffer: doc.output('arraybuffer'),
			pdfFileName: this.global.user().PE_Nome
		};
	}

	generatorDocumentFormITBI(data: IDataITBIPdf): IPdfData {
		const doc = new jsPDF('p', 'mm', 'a4');
		let pdfBase64;
		this.renderHeader(doc);
		this.drawHorizontalLine(38, doc);
		if (this.haveSubject(this.listRequestITBI, data.subject)) {
			this.renderBodyRequestITBI(doc, data);
		}
		if (data.subject == itbiFormEnum.ITBI_REQUERIMENTO) {
			this.renderBodyApplication(doc, data);
		}

		this.renderFooter(doc);
		pdfBase64 = doc.output('datauristring').split(',')[1];

		return {
			pdfBase64: doc.output('datauristring').split(',')[1],
			pdfBuffer: doc.output('arraybuffer'),
			pdfFileName: this.global.user().PE_Nome
		};
	}

	renderBodyApplication(doc: jsPDF, data: IDataITBIPdf) {
		doc.setFont('Inter-SemiBold');
		console.log("[document-form.renderBodyRequestITBI] data: ", data)
		doc.text(data.subject, doc.internal.pageSize.width / 2 || doc.internal.pageSize.getWidth() / 2, 50, { align: 'center' });

		const userOptionImovel: UserOptions = {
			theme: 'plain',
			tableLineColor: '#CCCCCC',
			headStyles: {
				lineColor: '#CCCCCC',
				lineWidth: 0.5
			},
			bodyStyles: {
				lineColor: '#CCCCCC',
				lineWidth: 0.5,
				fontSize: 8,
			},
			tableLineWidth: 0.5,
			styles: {
				fillColor: '#FFFFFF',
				cellPadding: 3,
				overflow: 'linebreak',
				fontSize: 9,
				lineColor: "#CCCCCC",
				lineWidth: 0.5,
			}
		}
		const dataTable: IDataTable[] = [
			{
				title: "DADOS DO SOLICITANTE",
				contents: [
					{ title: "IDENTIFICAÇÃO: ", content: `${this.formatCpfCnpj(data.solicitante.SOLR_CpfCnpj)} - ${data.solicitante.SOLR_NomeRazaoSocial}` },
					{ title: "EMAIL: ", content: data.solicitante.SOLR_Email },
				],
				height: null,
				columns: 1
			},
			{
				title: "DADOS DA SOLICITAÇÃO",
				contents: [
					{ title: "ORGÃO: ", content: data.org },
					{ title: "ASSUNTO: ", content: data.subject },
				],
				height: null,
				columns: 2
			},
			{
				title: "DESCRIÇÃO DA SOLICITAÇÃO",
				contents: [
					{ title: "", content: data.description },
				],
				height: null,
				columns: 1
			},
			{
				title: "DADOS DO ADQUIRENTE",
				contents: [
					{ title: "ADQUIRENTE: ", content: `${this.formatCpfCnpj(data.form.SOLIT_AdquirenteCPF)} - ${data.form.SOLIT_AdquirenteNome}` },
					{ title: "ENDEREÇO: ", content: `${data.form.SOLIT_AdquirenteLogradouro}, ${data.form.SOLIT_AdquirenteNumero}, ${data.form.SOLIT_AdquirenteBairro}, ${data.form.SOLIT_AdquirenteMunicipio} - ${data.form.SOLIT_AdquirenteUF} - ${this.formatCEP(data.form.SOLIT_AdquirenteCEP)}` },
				],
				height: null,
				columns: 1
			},
			{
				title: "DADOS DO TRANSMITENTE",
				contents: [
					{ title: "TRANSMITENTE: ", content: `${this.formatCpfCnpj(data.form.SOLIT_TransmitenteCPF)} - ${data.form.SOLIT_TransmitenteNome}` },
					{ title: "ENDEREÇO: ", content: `${data.form.SOLIT_TransmitenteLogradouro}, ${data.form.SOLIT_TransmitenteNumero}, ${data.form.SOLIT_TransmitenteBairro}, ${data.form.SOLIT_TransmitenteMunicipio} - ${data.form.SOLIT_TransmitenteUF} - ${this.formatCEP(data.form.SOLIT_TransmitenteCEP)}` }
				],
				height: null,
				columns: 1
			},
			{
				title: "INFORMAÇÕES DA TRANSAÇÃO",
				contents: [
					{ title: "NATUREZA DA TRANSAÇÃO: ", content: data.form.SOLIT_NaturezaTransacao },
				],
				height: null,
				columns: 1
			},
			{
				title: "DADOS DO IMÓVEL OBJETO DE TRANSAÇÃO",
				contents: [
					{ title: "INSCRIÇÃO DO IMÓVEL: ", content: data.form.SOLIT_TransacaoInscricao },
					{ title: "ENDEREÇO: ", content: `${data.form.SOLIT_TransacaoEndereco}, ${data.form.SOLIT_TransacaoNumero}, ${data.form.SOLIT_TransacaoComplemento}` },
					{ title: "NATUREZA DA TRANSAÇÃO: ", content: `${data.form.SOLIT_NaturezaTransacao}` },
				],
				columns: 3,
				distanceTable: 0.1,
				userOptions: { ...userOptionImovel }
			},
			{
				title: "",
				contents: [
					{ title: "LOTE: ", content: data.form.SOLIT_TransacaoLote ? data.form.SOLIT_TransacaoLote : "-" },
					{ title: "QUADRA: ", content: data.form.SOLIT_TransacaoQuadra ? data.form.SOLIT_TransacaoQuadra : "-" },
					{ title: "TIPO DE IMÓVEL: ", content: data.form.SOLIT_TransacaoTipoImovel ? data.form.SOLIT_TransacaoTipoImovel : "-" },
					{ title: "ÁREA DO TERRENO: ", content: data.form.SOLIT_TransacaoAreaTerreno ? data.form.SOLIT_TransacaoAreaTerreno + "m²" : "-" },
					{ title: "FRAÇÃO IDEAL: ", content: data.form.SOLIT_TransacaoFracaoIdeal ? data.form.SOLIT_TransacaoFracaoIdeal : "-" },
				],
				columns: 5,
				distanceTable: 0.1,
				userOptions: { ...userOptionImovel }
			},
			{
				title: "",
				contents: [
					{ title: "ÁREA EDIFICADA PRIVADA: ", content: data.form.SOLIT_TransacaoAreaPrivada ? data.form.SOLIT_TransacaoAreaPrivada + "m²" : "-" },
					{ title: "ÁREA EDIFICADA TOTAL: ", content: data.form.SOLIT_TransacaoAreaTotal ? data.form.SOLIT_TransacaoAreaTotal + "m²" : "-" },
					{ title: "VALOR NÃO FINANCIADO: ", content: data.form.SOLIT_TransacaoValorNaoFinanciado ? "R$" + data.form.SOLIT_TransacaoValorNaoFinanciado : "-" },
				],
				columns: 3,
				distanceTable: 0.1,
				userOptions: { ...userOptionImovel }
			},
			{
				title: "",
				contents: [
					{ title: "VALOR FINANCIADO: ", content: data.form.SOLIT_TransacaoValorFinanciado ? "R$" + data.form.SOLIT_TransacaoValorFinanciado : "-" },
					{ title: "TOTAL DECLARADO: ", content: data.form.SOLIT_TransacaoTotalDeclarado ? "R$" + data.form.SOLIT_TransacaoTotalDeclarado : "-" },
				],
				columns: 2,
				userOptions: { ...userOptionImovel }
			},
			{
				title: "",
				contents: [
					{ title: "", content: 'Constitui crime contra a ordem tributária suprimir ou reduzir tributo mediante declaração falsa às autoridades fazendárias. Pena de reclusão de 2 (dois) a 5 (cinco) anos, e multa. (Art. 1º, I, Lei Federal 8.137/90) A base de cálculo do imposto é o valor de mercado dos imóveis objetos da transação e dos bens ou direitos transmitidos, apurados na data do efetivo recolhimento do tributo. (CTM art. 159, Lei Complementar 006/2013 de 23 de dezembro 2013).' },
				],
				height: null,
				userOptions: {
					...userOptionImovel,
					bodyStyles: {
						fontStyle: 'bold'
					}
				}
			},
			{
				title: "",
				contents: [
					{
						title: "", content: 'Declaro, para todos os fins, e sob as penas da lei, que participei, na qualidade de contribuinte ou responsável do imposto sobre transações imobiliárias por atos inter vivos, de negócio jurídico que constitui fato gerador deste tributo, estando ciente que, assumo, ainda, a total e irrestrita responsabilidade de declarar que estes atos correspondem à verdade, ficando ainda responsável por fornecer informações que servirão como base para o lançamento do ITBI e que, se a negociação não for realizada, devo informar a este fisco municipal, sob pena do crédito tributário ser inscrito na dívida ativa do município, para fins de cobrança administrativa e judicial, nos termos da legislação vigente.'
					},
				],
				height: null
			},
		]
		doc = this.generateTable(doc, dataTable);
	}

	renderBodyRequestITBI(doc: jsPDF, data: IDataITBIPdf) {
		doc.setFont('Inter-SemiBold');
		doc.text(data.subject, doc.internal.pageSize.width / 2 || doc.internal.pageSize.getWidth() / 2, 50, { align: 'center' });
		console.log("[document-form.renderBodyRequestITBI] data: ", data)
		const userOptionImovel: UserOptions = {
			theme: 'plain',
			tableLineColor: '#CCCCCC',
			headStyles: {
				lineColor: '#CCCCCC',
				lineWidth: 0.5
			},
			bodyStyles: {
				lineColor: '#CCCCCC',
				lineWidth: 0.5
			},
			tableLineWidth: 0.5,
			styles: {
				fillColor: '#FFFFFF',
				cellPadding: 3,
				overflow: 'linebreak',
				fontSize: 9,
				lineColor: "#CCCCCC",
				lineWidth: 0.5,
			}
		}

		const dataTable: IDataTable[] = [
			{
				title: "DADOS DO SOLICITANTE",
				contents: [
					{ title: "IDENTIFICAÇÃO: ", content: `${this.formatCpfCnpj(data.solicitante.SOLR_CpfCnpj)} - ${data.solicitante.SOLR_NomeRazaoSocial}` },
					{ title: "EMAIL: ", content: data.solicitante.SOLR_Email },
					{ title: "TELEFONE: ", content: this.formatTelefone(data.form.SOLIT_SolicitanteTelefone) },
					{ title: data.form.SOLIT_SolicitanteEstadoCivil ? "ESTADO CIVIL: " : "", content: data.form.SOLIT_SolicitanteEstadoCivil ? data.form.SOLIT_SolicitanteEstadoCivil : "" },
					{ title: "ENDEREÇO: ", content: `${data.form.SOLIT_SolicitanteLogradouro}, ${data.form.SOLIT_SolicitanteNumero}${data.form.SOLIT_SolicitanteComplemento ? ', ' + data.form.SOLIT_SolicitanteComplemento : ''}, ${data.form.SOLIT_SolicitanteBairro}, ${data.form.SOLIT_SolicitanteMunicipio} - ${data.form.SOLIT_SolicitanteCEP}` }
				],
				height: null,
				columns: 1
			},
			{
				title: "DADOS DA SOLICITAÇÃO",
				contents: [
					{ title: "ORGÃO: ", content: data.org },
					{ title: "ASSUNTO: ", content: data.subject },
				],
				height: null,
				columns: 2
			},
			{
				title: "DESCRIÇÃO DA SOLICITAÇÃO",
				contents: [
					{
						title: "",
						content: data.description
					},
				],
				height: null,
				columns: 1
			},
			{
				title: "DADOS DO IMÓVEL OBJETO DE TRANSAÇÃO",
				contents: [
					{ title: "INSCRIÇÃO DO IMÓVEL: ", content: data.form.SOLIT_Inscricao },
					{ title: "ENDEREÇO: ", content: `${data.form.SOLIT_Logradouro}, ${data.form.SOLIT_Numero},  ${data.form.SOLIT_Bairro}, ${data.form.SOLIT_Municipio} - ${data.form.SOLIT_CEP}` },
					{ title: "NATUREZA DA TRANSAÇÃO: ", content: `${data.form.SOLIT_NaturezaTransacao}` },
				],
				columns: 3,
				distanceTable: 0.1,
				userOptions: { ...userOptionImovel }
			},
			{
				title: "",
				contents: [
					{ title: "TIPO DE IMÓVEL : ", content: data.form.SOLIT_TipoImovel },
					{ title: "ÁREA DO TERRENO: ", content: data.form.SOLIT_AreaTerreno + " m²" },
					{ title: "ÁREA EDIFICADA TOTAL: ", content: data.form.SOLIT_AreaEdificadaTotal + " m²" },
					{ title: "VALOR DECLARADO: ", content: "R$ " + data.form.SOLIT_ValorDeclarado },
				],
				columns: 2,
				userOptions: { ...userOptionImovel }
			},
		];

		if (data.subject === "ITBI - SOLICITAÇÃO DE ISENÇÃO DE ITBI") {
			dataTable.push({
				title: "DESCRIÇÃO/MOTIVO: INCISO DO ART. 163",
				contents: [
					{
						title: "",
						content: (data.form.SOLIT_Descricao ? ` ${data.form.SOLIT_Descricao}` : '')
					},
				],
				height: null,
				columns: 1
			});
		}

		dataTable.push(
			{
				title: "",
				contents: [
					{ title: "", content: 'Constitui crime contra a ordem tributária suprimir ou reduzir tributo mediante declaração falsa às autoridades fazendárias. Pena de reclusão de 2 (dois) a 5 (cinco) anos, emulta. (Art. 1º, I, Lei Federal 8.137/90) A base de cálculo do imposto é o valor de mercado dos imóveis objetos da transação e dos bens ou direitos transmitidos, apurados na data do efetivo recolhimento do tributo. (CTM art. 159, Lei Complementar 006/2013 de 23 de dezembro 2013).' },
				],
				height: null,
				userOptions: {
					...userOptionImovel,
					bodyStyles: {
						fontStyle: 'bold'
					}
				}
			},
			{
				title: "",
				contents: [
					{
						title: "", content: 'Declaro, para todos os fins, e sob as penas da lei, que participei, na qualidade de contribuinte ou responsável do Imposto sobre Transações Imobiliárias por Atos Inter Vivos, de negócio jurídico que constitui fato gerador deste tributo, estando ciente que, assumo, ainda, a total e irrestrita responsabilidade de declarar que estes atos correspondem à verdade, ficando ainda responsável por fornecer informações que servirão como base para o lançamento do ITBI e que, se a negociação não for realizada, devo informar a este fisco municipal, sob pena do crédito tributário ser inscrito na dívida ativa do município, para fins de cobrança administrativa e judicial, nos termos da legislação vigente.'
					},
				],
				height: null
			}
		);

		doc = this.generateTable(doc, dataTable);
	}

	renderBodyOrgaoCedido(doc: jsPDF, data) {
		doc.setFont('Inter-SemiBold');
		doc.text(data.subject, doc.internal.pageSize.width / 2 || doc.internal.pageSize.getWidth() / 2, 50, { align: 'center' });
		const solicitante = data.form.applicantIdentification;
		const dataTable = [
			{
				title: "DADOS DO SOLICITANTE",
				contents: [
					{ title: "IDENTIFICAÇÃO: ", content: `${this.formatCpfCnpj(solicitante.SOLIP_RequerenteCpfCnpj)} - ${data.solicitante.SOLR_NomeRazaoSocial}` },
					{ title: "RG: ", content: solicitante.SOLIP_RequerenteRG },
					{ title: "EMAIL: ", content: solicitante.SOLIP_RequerenteEmail },
					{ title: "TELEFONE: ", content: this.formatTelefone(solicitante.SOLIP_RequerenteTelefone) },
					{ title: "ESTADO CIVIL: ", content: solicitante.SOLIP_RequerenteEstadoCivil },
				],
				height: null,
				columns: 1
			},
			{
				title: "DADOS DA SOLICITAÇÃO",
				contents: [
					{ title: "ORGÃO: ", content: data.org },
					{ title: "ASSUNTO: ", content: data.subject },
				],
				height: null,
				columns: 2
			},
			{
				title: "DESCRIÇÃO DA SOLICITAÇÃO",
				contents: [
					{ title: "", content: data.description },
				],
				height: null
			},
			{
				title: "DADOS DO IMÓVEL",
				contents: [
					{ title: "INSCRIÇÃO: ", content: this.formatInscricaoIPTU(data.form.propertyData.SOLIP_InscricaoImovel) },
					{ title: "ENDEREÇO: ", content: `${data.form.propertyData.SOLIP_Logradouro}, ${data.form.propertyData.SOLIP_Numero}${data.form.propertyData.SOLIP_Complemento ? ', ' + data.form.propertyData.SOLIP_Complemento : ''}, ${data.form.propertyData.SOLIP_Bairro}, ${data.form.propertyData.SOLIP_Municipio} - ${this.formatCEP(data.form.propertyData.SOLIP_CEP)}` },
				],
				height: null,
				columns: 2
			},
			{
				title: "ÓRGÃO CEDIDO",
				contents: [
					{ title: "", content: data.form.propertyData.SOLIP_Descricao },
				],
				height: null
			},
			{
				title: null,
				contents: [
					{ title: "", content: "Declaro, nesta oportunidade, estar ciente de que o reconhecimento da isenção ora requerida dependerá da documentação abaixo relacionada, e que a ausência de qualquer um dos referidos documentos poderá inviabilizar a análise do pedido ora formulado com o consequente arquivamento do processo." },
				],
				height: null
			}
		]
		doc = this.generateTable(doc, dataTable);

		return doc
	}

	public generatorDocumentFormSEAD(data): IPdfData {
		const doc = new jsPDF('p', 'mm', 'a4');
		doc.setFont("helvetica", "bold");

		this.renderHeader(doc);
		this.drawHorizontalLine(38, doc);
		doc.text("Documento de Solicitação - SEAD", doc.internal.pageSize.width / 2 || doc.internal.pageSize.getWidth() / 2, 50, { align: 'center' });
		this.generateTable(doc, data);
		this.renderFooter(doc);

		return {
			pdfBase64: doc.output('datauristring').split(',')[1],
			pdfBuffer: doc.output('arraybuffer'),
			pdfFileName: this.global.user().PE_Nome
		};
	}

	public generateDocumentFormDefault(data): IPdfData {
		const doc = new jsPDF('p', 'mm', 'a4');
		doc.setFont("helvetica", "bold");

		this.renderHeader(doc);
		this.drawHorizontalLine(38, doc);
		doc.text("DOCUMENTO DE SOLICITAÇÃO", doc.internal.pageSize.width / 2 || doc.internal.pageSize.getWidth() / 2, 50, { align: 'center' });

		var tableData = [
			{
				title: "DADOS DO SOLICITANTE",
				contents: [
					{
						title: "SOLICITANTE: ",
						content: this.formatCpfCnpj(data.solicitante.PE_CPF) + " - " + data.solicitante.PE_Nome
					}
				]
			},
			{
				title: "DADOS DA SOLICITAÇÃO",
				contents: [
					{
						title: "ORGÃO: ",
						content: data.orgao
					},
					{
						title: "ASSUNTO: ",
						content: data.assunto
					}
				]
			},
			{
				title: "DESCRIÇÃO DA SOLICITAÇÃO",
				contents: [
					{ title: "", content: data.description },
				],
				height: null
			},
			{
				title: null,
				contents: [
					{
						title: null,
						content: "Declaro, para fins de direito, sob as penas da lei, que as informações acima prestadas e documentos são verdadeiros e autênticos. Atesto que estou ciente de que, se constatada falsidade ideológica ou documental responderei civil e criminalmente, na forma do art. 299 e seguinte Código Penal."
					}
				]
			}
		];

		if (data.applicantRequest) {
			var requerente = {
				title: "DADOS DO REQUERENTE",
				contents: [
					{
						title: "REQUERENTE: ",
						content: this.formatCpfCnpj(data.requerente.SOLR_CpfCnpj) + " - " + data.requerente.SOLR_NomeRazaoSocial
					}
				]
			};
			tableData.splice(1, 0, requerente);
		}

		this.generateTable(doc, tableData);

		return {
			pdfBase64: doc.output('datauristring').split(',')[1],
			pdfBuffer: doc.output('arraybuffer'),
			pdfFileName: this.global.user().PE_Nome
		};
	}

	renderSemFinsLucrativos(doc: jsPDF, data) {
		doc.setFont('Inter-SemiBold');
		doc.text(data.subject, doc.internal.pageSize.width / 2 || doc.internal.pageSize.getWidth() / 2, 50, { align: 'center' });
		const solicitante = data.form.applicantCompany
		console.log("[document-form.renderSemFinsLucrativos] data: ", data)
		const dataTable = [
			{
				title: "DADOS DO SOLICITANTE",
				contents: [
					{ title: "IDENTIFICAÇÃO: ", content: `${this.formatCpfCnpj(solicitante.SOLIP_RequerenteCpfCnpj)} - ${solicitante.SOLIP_RequerenteNomeRazaoSocial}` },
					{ title: "CNAE: ", content: solicitante.SOLIP_RequerenteCNAE },
					{ title: "EMAIL: ", content: solicitante.SOLIP_RequerenteEmail },
					{ title: "TELEFONE: ", content: this.formatTelefone(solicitante.SOLIP_RequerenteTelefone) },
				],
				height: null,
				columns: 1
			},
			{
				title: "DADOS DA SOLICITAÇÃO",
				contents: [
					{ title: "ORGÃO: ", content: data.org },
					{ title: "ASSUNTO: ", content: data.subject },
				],
				height: null,
				columns: 2
			},
			{
				title: "DESCRIÇÃO DA SOLICITAÇÃO",
				contents: [
					{ title: "", content: data.description },
				],
				height: null
			},
			{
				title: "DADOS DO IMÓVEL",
				contents: [
					{ title: "INSCRIÇÃO: ", content: this.formatInscricaoIPTU(data.form.propertyData.SOLIP_InscricaoImovel) },
					{ title: "ENDEREÇO: ", content: `${data.form.propertyData.SOLIP_Logradouro}, ${data.form.propertyData.SOLIP_Numero}${data.form.propertyData.SOLIP_Complemento ? ', ' + data.form.propertyData.SOLIP_Complemento : ''}, ${data.form.propertyData.SOLIP_Bairro}, ${data.form.propertyData.SOLIP_Municipio} - ${this.formatCEP(data.form.propertyData.SOLIP_CEP)}` },
				],
				height: null,
				columns: 2
			},
			{
				title: "EXERCICIO(S) SOLICITADO(S)",
				contents: [
					{ title: "", content: data.form.propertyData.SOLIP_Descricao },
				],
				height: null
			},
			{
				title: null,
				contents: [
					{ title: "", content: "Declaro, nesta oportunidade, estar ciente de que o reconhecimento da isenção ora requerida dependerá da documentação abaixo relacionada, e que a ausência de qualquer um dos referidos documentos poderá inviabilizar a análise do pedido ora formulado com o consequente arquivamento do processo." },
				],
				height: null
			}
		]

		doc = this.generateTable(doc, dataTable);

		return doc
	}

	renderBodyDefaultIptu(doc: jsPDF, data) {
		doc.setFont('Inter-SemiBold');
		doc.text(data.subject, doc.internal.pageSize.width / 2 || doc.internal.pageSize.getWidth() / 2, 50, { align: 'center' });

		const solicitante = data.form.applicantIdentification

		const dataTable = [
			{
				title: "DADOS DO SOLICITANTE",
				contents: [
					{ title: "IDENTIFICAÇÃO: ", content: `${this.formatCpfCnpj(solicitante.SOLIP_RequerenteCpfCnpj)} - ${solicitante.SOLIP_RequerenteNomeRazaoSocial}` },
					{ title: "RG: ", content: solicitante.SOLIP_RequerenteRG },
					{ title: "ESTADO CIVIL: ", content: solicitante.SOLIP_RequerenteEstadoCivil },
					{ title: "EMAIL: ", content: solicitante.SOLIP_RequerenteEmail },
					{ title: "TELEFONE: ", content: this.formatTelefone(solicitante.SOLIP_RequerenteTelefone) },
				],
				height: null,
				columns: 1
			},
			{
				title: "DADOS DA SOLICITAÇÃO",
				contents: [
					{ title: "ORGÃO: ", content: data.org },
					{ title: "ASSUNTO: ", content: data.subject },
				],
				height: null,
				columns: 2
			},
			{
				title: "DESCRIÇÃO DA SOLICITAÇÃO",
				contents: [
					{ title: "", content: data.description }
				],
				height: null
			},
			{
				title: "DADOS DO IMÓVEL",
				contents: [
					{ title: "INSCRIÇÃO: ", content: this.formatInscricaoIPTU(data.form.propertyData.SOLIP_InscricaoImovel) },
					{ title: "ENDEREÇO: ", content: `${data.form.propertyData.SOLIP_Logradouro}, ${data.form.propertyData.SOLIP_Numero}${data.form.propertyData.SOLIP_Complemento ? ', ' + data.form.propertyData.SOLIP_Complemento : ''}, ${data.form.propertyData.SOLIP_Bairro}, ${data.form.propertyData.SOLIP_Municipio} - ${this.formatCEP(data.form.propertyData.SOLIP_CEP)}` },
				],
				height: null,
				columns: 2
			},
			{
				title: null,
				contents: [
					{ title: "", content: "Declaro, nesta oportunidade, estar ciente de que o reconhecimento da isenção ora requerida dependerá da documentação relacionada, e que a ausência de qualquer um dos referidos documentos poderá inviabilizar a análise do pedido ora formulado com o consequente arquivamento do processo." },
				],
				height: null
			}
		]

		if (data.subject === iptuFormEnum.IPTU_ISENÇÃO_VIÚVAS) {
			dataTable.push({
				title: "TIPO DE ISENÇÃO",
				contents: [
					{ title: "", content: data.form.propertyData.SOLIP_Descricao }
				],
				height: null
			});
		}

		doc = this.generateTable(doc, dataTable);

		return doc;
	}

	renderBodyRequerimentoIptu(doc: jsPDF, data) {

		doc.setFont('Inter-SemiBold');
		doc.text(data.subject, doc.internal.pageSize.width / 2 || doc.internal.pageSize.getWidth() / 2, 50, { align: 'center' });

		const solicitante = data.form.applicantData;
		const dataTable = [
			{
				title: "DADOS DO SOLICITANTE",
				contents: [
					{ title: "IDENTIFICAÇÃO: ", content: `${this.formatCpfCnpj(solicitante.SOLIP_RequerenteCpfCnpj)} - ${solicitante.SOLIP_RequerenteNomeRazaoSocial}` },
					{ title: "ENDEREÇO: ", content: `${solicitante.SOLIP_RequerenteLogradouro}, ${solicitante.SOLIP_RequerenteNumero}${solicitante.SOLIP_RequerenteComplemento ? ', ' + solicitante.SOLIP_RequerenteComplemento : ''}, ${solicitante.SOLIP_RequerenteBairro}, ${solicitante.SOLIP_RequerenteMunicipio} - ${this.formatCEP(solicitante.SOLIP_RequerenteCEP)}` },
					{ title: "EMAIL: ", content: solicitante.SOLIP_RequerenteEmail },
					{ title: "TELEFONE: ", content: this.formatTelefone(solicitante.SOLIP_RequerenteTelefone) },
				],
				height: null,
				columns: 1
			},
			{
				title: "DADOS DA SOLICITAÇÃO",
				contents: [
					{ title: "ORGÃO: ", content: data.org },
					{ title: "ASSUNTO: ", content: data.subject },
				],
				height: null,
				columns: 2
			},
			{
				title: 'IDENTIFICAÇÃO DA SOLICITAÇÃO',
				contents: [
					{ title: "", content: data.form.propertyData.SOLIP_Descricao },
				],
				height: null
			},
			{
				title: "DESCRIÇÃO",
				contents: [
					{ title: "", content: data.description },
				],
				height: null
			},
			{
				title: "DADOS DO IMÓVEL",
				contents: [
					{ title: "INSCRIÇÃO: ", content: this.formatInscricaoIPTU(data.form.propertyData.SOLIP_InscricaoImovel) },
					{ title: "ENDEREÇO: ", content: `${data.form.propertyData.SOLIP_Logradouro}, ${data.form.propertyData.SOLIP_Numero}${data.form.propertyData.SOLIP_Complemento ? ', ' + data.form.propertyData.SOLIP_Complemento : ''}, ${data.form.propertyData.SOLIP_Bairro}, ${data.form.propertyData.SOLIP_Municipio} - ${this.formatCEP(data.form.propertyData.SOLIP_CEP)}` },
					{ title: "CARTOGRAFIA: ", content: data.form.propertyData.SOLIP_Cartografia },
				],
				height: null,
				columns: 1,
			},
			{
				title: '',
				contents: [
					{ title: '', content: 'Constitui crime contra a ordem tributária suprimir ou reduzir tributo mediante declaração falsa às autoridades fazendárias. Pena de reclusão de 2 (dois) a 5 (cinco) anos, e multa. (Art. 1º, I, Lei Federal 8.137/90). A base de cálculo do imposto é o valor de mercado dos imóveis objetos da transação e dos bens ou direitos transmitidos, apurados na data do efetivo recolhimento do tributo. (CTM Art. 159, Lei Complementar 006/2013 de 23 de dezembro de 2013).' }
				]
			},
			{
				title: null,
				contents: [
					{ title: "", content: "Declaro, nesta oportunidade, estar ciente de que o reconhecimento da isenção ora requerida dependerá da documentação abaixo relacionada, e que a ausência de qualquer um dos referidos documentos poderá inviabilizar a análise do pedido ora formulado com o consequente arquivamento do processo." },
				],
				height: null
			},
		]

		doc = this.generateTable(doc, dataTable);
		return doc;
	}

	renderBodyRequerimentoImunidade(doc: jsPDF, data) {
		doc.setFont('Inter-SemiBold');
		doc.text(data.subject, doc.internal.pageSize.width / 2 || doc.internal.pageSize.getWidth() / 2, 50, { align: 'center' });

		const solicitante = data.form.immunityRequest;
		const immunityData = data.form.immunityData;

		let properties = {
			title: "IDENTIFICAR O(S) IMÓVEIS, NA FORMA ABAIXO: ",
			contents: [

			],
			height: null,
			columns: 2
		}

		for (let item of immunityData) {
			properties.contents.push(
				{
					title: "INSCRIÇÃO DO IMÓVEL: ",
					content: this.formatInscricaoIPTU(item.SOLII_InscricaoImovel)
				}
			);
			properties.contents.push(
				{
					title: "ENDEREÇO: ",
					content: item.SOLII_Endereco + ", " + this.formatCEP(item.SOLII_CEP)
				}
			)
		}

		const dataTable = [
			{
				title: "DADOS DO SOLICITANTE",
				contents: [
					{ title: "IDENTIFICAÇÃO: ", content: `${this.formatCpfCnpj(solicitante.SOLIP_RequerenteCpfCnpj)} - ${solicitante.SOLIP_RequerenteNomeRazaoSocial}` },
					{ title: "INSCRIÇÃO DO ISS: ", content: solicitante.SOLIP_RequerenteInscricaoIss },
					{ title: "ENDEREÇO: ", content: `${solicitante.SOLIP_RequerenteLogradouro}, ${solicitante.SOLIP_RequerenteNumero}${solicitante.SOLIP_RequerenteComplemento ? ', ' + solicitante.SOLIP_RequerenteComplemento : ''}, ${solicitante.SOLIP_RequerenteBairro}, ${solicitante.SOLIP_RequerenteMunicipio} - ${this.formatCEP(solicitante.SOLIP_RequerenteCEP)}` },
					{ title: "EMAIL: ", content: solicitante.SOLIP_RequerenteEmail },
					{ title: "TELEFONE: ", content: this.formatTelefone(solicitante.SOLIP_RequerenteTelefone) },
					{ title: "REPRESENTANTE LEGAL: ", content: `${this.formatCpfCnpj(solicitante.SOLIP_RequerenteRepresentanteCpf)} - ${solicitante.SOLIP_RequerenteRepresentanteNome}` },
				],
				height: null,
				columns: 1
			},
			{
				title: "DADOS DA SOLICITAÇÃO",
				contents: [
					{ title: "ORGÃO: ", content: data.org },
					{ title: "ASSUNTO: ", content: data.subject },
				],
				height: null,
				columns: 2
			},
			{
				title: "DESCRIÇÃO DA SOLICITAÇÃO",
				contents: [
					{ title: "", content: data.description },
				],
				height: null
			},
			{
				title: "REQUERIMENTO",
				contents: [
					{ title: "", content: "O requerente acima identificado, por intermédio de seu representante legal, vem requerer o reconhecimento da imunidade tributária, relacionada ao(s) IPTU por se tratar de instituição que possui a finalidade adiante especificada." },
				],
				height: null
			},
			{
				title: "FINALIDADE ESSENCIAL DA INSTITUIÇÃO",
				contents: [
					{ title: "", content: solicitante.SOLIP_Descricao },
				],
				height: null
			},
			properties,
			{
				title: null,
				contents: [
					{ title: "", content: "Declaro, nesta oportunidade, estar ciente de que o reconhecimento da isenção ora requerida dependerá da documentação abaixo relacionada, e que a ausência de qualquer um dos referidos documentos poderá inviabilizar a análise do pedido ora formulado com o consequente arquivamento do processo." },
				],
				height: null
			},
			{
				title: null,
				contents: [
					{ title: "", content: "Observação: Havendo deferimento do pedido e constatado posteriormente o descumprimento de quaisquer requisitos previstos na legislação, a imunidade será suspensa (art. 10, § 2º, da Lei Complementar nº 06/2013 - Código Tributário do Município)." },
				],
				height: null
			}
		]

		doc = this.generateTable(doc, dataTable);
		return doc;
	}

	renderBodyIsencaoDoenca(doc: jsPDF, data) {

		doc.setFont('Inter-SemiBold');
		doc.text(data.subject, doc.internal.pageSize.width / 2 || doc.internal.pageSize.getWidth() / 2, 50, { align: 'center' });

		const solicitante = data.form.applicantData;
		const disease = data.form.diseaseData;
		const dataTable = [
			{
				title: "DADOS DO SOLICITANTE",
				contents: [
					{ title: "IDENTIFICAÇÃO: ", content: `${this.formatCpfCnpj(solicitante.SOLIP_RequerenteCpfCnpj)}-${solicitante.SOLIP_RequerenteNomeRazaoSocial}` },
					{ title: "RG: ", content: solicitante.SOLIP_RequerenteRG },
					{ title: "EMAIL: ", content: solicitante.SOLIP_RequerenteEmail },
					{ title: "TELEFONE: ", content: this.formatTelefone(solicitante.SOLIP_RequerenteTelefone) },
				],
				columns: 1
			},
			{
				title: "DADOS DO PORTADOR DA DOENÇA GRAVE",
				contents: [
					{ title: "IDENTIFICAÇÃO: ", content: `${this.formatCpfCnpj(disease.SOLIP_DoenteCpf)} - ${disease.SOLIP_DoenteNome}` },
					{ title: "RG: ", content: disease.SOLIP_DoenteRG },
					{ title: "VÍNCULO COM O PORTADOR DA DOENÇA: ", content: disease.SOLIP_DoenteVinculo ? disease.SOLIP_DoenteVinculo : '-' },
					{ title: "DOENÇA GRAVE/CID: ", content: disease.SOLIP_Doenca },
				],
				columns: 1
			},
			{
				title: "DADOS DA SOLICITAÇÃO",
				contents: [
					{ title: "ORGÃO: ", content: data.org },
					{ title: "ASSUNTO: ", content: data.subject },
				],
				columns: 2
			},
			{
				title: "DADOS DO IMÓVEL",
				contents: [
					{ title: "INSCRIÇÃO: ", content: this.formatInscricaoIPTU(data.form.propertyData.SOLIP_InscricaoImovel) },
					{ title: "ENDEREÇO: ", content: `${data.form.propertyData.SOLIP_Logradouro}, ${data.form.propertyData.SOLIP_Numero}${data.form.propertyData.SOLIP_Complemento ? ', ' + data.form.propertyData.SOLIP_Complemento : ''}, ${data.form.propertyData.SOLIP_Bairro}, ${data.form.propertyData.SOLIP_Municipio} - ${this.formatCEP(data.form.propertyData.SOLIP_CEP)}` },
				],
				columns: 2
			},
			{
				title: "REQUERIMENTO",
				contents: [
					{ title: "", content: "Eu, acima identificado, declaro estar ciente de que o reconhecimento da isenção ora requerida dependerá do preenchimento das condições e requisitos exigidos na legislação em vigor, bem como da apresentação da documentação relacionada no verso deste requerimento, e que a ausência de qualquer um dos referidos documentos poderá inviabilizar a análise do pedido ora formulado com o consequente arquivamento do processo." },
				]
			}
		]

		doc = this.generateTable(doc, dataTable);

		return doc;
	}

	public generatorDocumentFormInscricao(data): IPdfData {
		console.log('[DATA FORM INSCRICAO]', data);
		const doc = new jsPDF('p', 'mm', 'a4');
		doc.setFont('Inter-SemiBold');
		doc.text('Documento de Solicitação de Inscrição Municipal', doc.internal.pageSize.width / 2 || doc.internal.pageSize.getWidth() / 2, 50, { align: 'center' });

		let partners = {
			title: 'SÓCIOS: ',
			contents: [],
			height: null,
			columns: 2
		};

		for (const item of data.form.partnersData) {
			partners.contents.push(
				{
					title: 'CPF/CNPJ: ',
					content: this.formatCpfCnpj(item.SIS_CpfCnpj)
				}
			)
			partners.contents.push(
				{
					title: 'NOME/RAZÃO SOCIAL: ',
					content: item.SIS_NomeRazaoSocial
				}
			)
		}

		const dataTable = [
			{
				title: 'DADOS DO SOLICITANTE',
				contents: [
					{
						title: 'SOLICITANTE: ',
						content: `${this.formatCpfCnpj(data.form.SIM_RequerenteCpfCnpj)} - ${data.form.SIM_RequerenteRazaoSocial}`
					},
					{
						title: 'E-MAIL: ',
						content: data.form.SIM_RequerenteEmail
					},
					{
						title: 'TELEFONE: ',
						content: this.formatTelefone(data.form.SIM_RequerenteTelefone)
					},
					{
						title: 'INSCRIÇÃO MUNICIPAL: ',
						content: data.form.SIM_Inscricao
					},
					{
						title: 'INÍCIO ATIVIDADE NA RFB: ',
						content: this.formatDate(data.form.SIM_AtividadeRfb)
					},
					{
						title: 'INÍCIO ATIVIDADE NO MUNICÍPIO: ',
						content: this.formatDate(data.form.SIM_AtividadeMunicipio)
					},
					{
						title: 'ENDEREÇO: ',
						content: `${data.form.SIM_RequerenteLogradouro}, ${data.form.SIM_RequerenteNumero}${data.form.SIM_RequerenteComplemento ? ', ' + data.form.SIM_RequerenteComplemento : ''}, ${data.form.SIM_RequerenteBairro}, ${data.form.SIM_RequerenteMunicipio} - ${this.formatCEP(data.form.SIM_RequerenteCEP)}`
					},
				],
				columns: 1
			},
			{
				title: 'DADOS DA SOLICITAÇÃO',
				contents: [
					{
						title: 'ORGÃO: ',
						content: data.org
					},
					{
						title: 'ASSUNTO: ',
						content: data.subject
					}
				],
				columns: 2
			},
			{
				title: 'DADOS DO IMÓVEL ONDE SERÁ LICENCIADO A ATIVIDADE',
				contents: [
					{
						title: 'INSCRIÇÃO DO IMÓVEL: ',
						content: data.form.SIM_InscricaoIptu
					},
					{
						title: 'ÁREA TOTAL UTILIZADA: ',
						content: data.form.SIM_AreaUtilizada + 'm²'
					},
					{
						title: 'ENDEREÇO: ',
						content: `${data.form.SIM_Logradouro}, ${data.form.SIM_Numero}, ${data.form.SIM_Bairro}, SÃO GONÇALO DO AMARANTE - CE - ${data.form.SIM_CEP}`
					},
				],
				columns: 1
			},
			{
				title: 'DADOS DA ATIVIDADE PRINCIPAL',
				contents: [
					{
						title: 'CÓDIGO: ',
						content: data.form.SIA_CodigoAtividade
					},
					{
						title: 'DESCRIÇÃO: ',
						content: data.form.SIA_AtividadePrincipal
					},
					{
						title: 'ESPÉCIE DO CONTRIBUINTE: ',
						content: data.form.SIM_EspecieRequerente
					},
					{
						title: 'TIPO DE TRIBUTAÇÃO: ',
						content: data.form.SIM_TipoTributacao
					}
				],
				columns: 1
			},
			{
				title: 'RESPONSÁVEL CONTÁBIL',
				contents: [
					{
						title: 'IDENTIFICAÇÃO: ',
						content: `${this.formatCpfCnpj(data.form.SIM_ResponsavelCpfCnpj)} - ${data.form.SIM_ResponsavelRazaoSocial}`
					},
					{
						title: 'CRC: ',
						content: data.form.SIM_CRC
					}
				]
			},
			partners,
			{
				title: 'RESPONSÁVEL LEGAL DA PESSOA JURÍDICA',
				contents: [
					{
						title: 'IDENTIFICAÇÃO: ',
						content: `${this.formatCpfCnpj(data.form.SIM_ResponsavelLegalCpfCnpj)} - ${data.form.SIM_ResponsavelLegalNome}`
					},
					{
						title: 'QUALIFICAÇÃO: ',
						content: data.form.SIM_ResponsavelLegalQualificacao
					}
				],
				columns: 2
			},
			{
				contents: [
					{
						title: '',
						content: 'Declaro, para fins de direito, sob as penas da lei, que as informações acima prestadas e documentos são verdadeiros e autênticos. atesto que estou ciente de que, se constatada falsidade ideológica ou documental responderei civil e criminalmente, na forma do art. 299 e seguinte código penal.'
					}
				]
			}
		];

		this.renderHeader(doc);
		this.drawHorizontalLine(38, doc);
		this.generateTable(doc, dataTable);
		this.renderFooter(doc);

		const pdfBase64 = doc.output('datauristring').split(',')[1];

		return {
			pdfBase64: doc.output('datauristring').split(',')[1],
			pdfBuffer: doc.output('arraybuffer'),
			pdfFileName: this.global.user().PE_Nome
		};
	}

	public generatorDocumentFormAlvara(data: IDataITBIPdf): IPdfData {
		const doc = new jsPDF('p', 'mm', 'a4');

		this.renderHeader(doc);
		this.drawHorizontalLine(38, doc);
		doc.setFont('Inter-SemiBold');

		const dataTable: IDataTable[] = [];

		dataTable.push({
			title: 'DADOS DO SOLICITANTE',
			contents: [
				{
					title: 'IDENTIFICAÇÃO: ',
					content: `${this.formatCpfCnpj(data.usuarioLogado.SOLR_CpfCnpj)} - ${data.usuarioLogado.SOLR_NomeRazaoSocial}`
				},
				{
					title: 'SUBSTITUTO TRIBUTÁRIO: ',
					content: data.form.SOLAL_SubstitutoTributario === 'SIM' ? 'Sim' : 'Não'
				},
				{
					title: 'INSCRIÇÃO MUNICIPAL: ',
					content: data.form.SOLAL_InscricaoMunicipal || 'Não informada'
				},
				{
					title: 'INÍCIO DA ATIVIDADE NO MUNICÍPIO: ',
					content: data.form.SOLAL_InicioAtividadeMunicipio
						? this.formatDate(data.form.SOLAL_InicioAtividadeMunicipio)
						: ''
				},
				{
					title: 'INÍCIO DA ATIVIDADE NA RFB: ',
					content: this.formatDate(data.form.SOLAL_InicioAtividadeRFB)
				},
				{
					title: 'E-MAIL: ',
					content: data.usuarioLogado.SOLR_Email
				},
				{
					title: 'TELEFONE: ',
					content: this.formatTelefone(data.usuarioLogado.SOLR_Telefone)
				},
				{
					title: 'ENDEREÇO: ',
					content: `${data.form.SOLAL_Logradouro}, ${data.form.SOLAL_Numero}${data.form.SOLAL_Complemento ? ', ' + data.form.SOLAL_Complemento : ''}, ${data.form.SOLAL_Bairro}, ${data.form.SOLAL_Municipio} - ${this.formatCEP(data.form.SOLAL_CEP)}`
				}
			],
			columns: 1
		});

		if (data.usuarioLogado.SOLR_CpfCnpj !== data.solicitante.SOLR_CpfCnpj) {
			dataTable.push({
				title: 'DADOS DO REQUERENTE',
				contents: [
					{
						title: 'IDENTIFICAÇÃO: ',
						content: `${this.formatCpfCnpj(data.solicitante.SOLR_CpfCnpj)} - ${data.solicitante.SOLR_NomeRazaoSocial}`
					},
					{
						title: 'E-MAIL: ',
						content: data.solicitante.SOLR_Email
					},
					{
						title: 'TELEFONE: ',
						content: this.formatTelefone(data.solicitante.SOLR_Telefone)
					}
				],
				columns: 1
			});
		}

		dataTable.push({
			title: 'DADOS DO IMÓVEL ONDE SERÁ LICENCIADA A ATIVIDADE',
			contents: [
				{ 
					title: 'INSCRIÇÃO IPTU: ', 
					content: data.form.SOLAL_InscricaoIPTU || 'Não informada' 
				},
				{ 
					title: 'ÁREA TOTAL UTILIZADA: ', 
					content: `${data.form.SOLAL_AreaTotal} m²` 
				},
				{
					title: 'ENDEREÇO DO IMÓVEL: ',
					content: `${data.form.SOLAL_ImovelLogradouro}, ${data.form.SOLAL_ImovelNumero}${data.form.SOLAL_ImovelComplemento ? ', ' + data.form.SOLAL_ImovelComplemento : ''}, ${data.form.SOLAL_ImovelBairro}, ${data.form.SOLAL_ImovelMunicipio} - ${this.formatCEP(data.form.SOLAL_ImovelCEP)}`
				}
			],
			columns: 1
		});

		const atividadesContents = [];
		data.form.atividades.forEach((atv, index) => {
			atividadesContents.push({
				title: `ATIVIDADE ${index + 1}`,
				content: '',
				isSubsection: true,
				colSpan: 2
			});
			
			atividadesContents.push(
				{ 
					title: `CNAE: `, 
					content: atv.SOLAL_CNAE 
				},
				{ 
					title: `DESCRIÇÃO: `, 
					content: atv.SOLAL_DescricaoAtividade 
				},
				{ 
					title: `ESPÉCIE DE CONTRIBUINTE: `, 
					content: this.getEspecieContribuinteLabel(atv.SOLAL_EspecieContribuinte) 
				},
				{ 
					title: `TIPO DE TRIBUTAÇÃO: `, 
					content: this.getTipoTributacaoLabel(atv.SOLAL_TipoTributacao) 
				}
			);
			
			if (index < data.form.atividades.length - 1) {
				atividadesContents.push({
					title: '',
					content: '',
					isSpacer: true,
					colSpan: 2
				});
			}
		});
		
		dataTable.push({
			title: 'DADOS DAS ATIVIDADES',
			contents: atividadesContents,
			columns: 1
		});

		if (data.form.SOLAL_ContabilNome || data.form.SOLAL_ContabilCPFCNPJ || data.form.SOLAL_ContabilCRC) {
			dataTable.push({
				title: 'RESPONSÁVEL CONTÁBIL',
				contents: [
					{
						title: 'NOME / RAZÃO SOCIAL: ',
						content: data.form.SOLAL_ContabilNome || 'Não informado'
					},
					{
						title: 'CPF/CNPJ: ',
						content: data.form.SOLAL_ContabilCPFCNPJ ? this.formatCpfCnpj(data.form.SOLAL_ContabilCPFCNPJ) : 'Não informado'
					},
					{
						title: 'CRC: ',
						content: data.form.SOLAL_ContabilCRC || 'Não informado'
					}
				],
				columns: 1
			});
		}

		if (data.form.socios && data.form.socios.length > 0) {
			const sociosContents = [];
			data.form.socios.forEach((socio, index) => {
				sociosContents.push({
					title: `SÓCIO ${index + 1}`,
					content: '',
					isSubsection: true,
					colSpan: 2
				});

				sociosContents.push(
					{
						title: `CPF/CNPJ: `, 
						content: this.formatCpfCnpj(socio.SOLAL_SocioCPFCNPJ)
					},
					{
						title: `NOME: `,
						content: socio.SOLAL_SocioNome
					}
				);

				if (index < data.form.socios.length - 1) {
					sociosContents.push({
						title: '',
						content: '',
						isSpacer: true,
						colSpan: 2
					});
				}
			});

			dataTable.push({
				title: 'SÓCIOS',
				contents: sociosContents,
				columns: 1
			});
		}

		if (data.form.SOLAL_ResponsavelNome || data.form.SOLAL_ResponsavelCPF || data.form.SOLAL_ResponsavelQualificacao) {
			dataTable.push({
				title: 'RESPONSÁVEL LEGAL DA PESSOA JURÍDICA',
				contents: [
					{
						title: 'NOME: ',
						content: data.form.SOLAL_ResponsavelNome || 'Não informado'
					},
					{
						title: 'CPF: ',
						content: data.form.SOLAL_ResponsavelCPF ? this.formatCpfCnpj(data.form.SOLAL_ResponsavelCPF) : 'Não informado'
					},
					{
						title: 'QUALIFICAÇÃO: ',
						content: data.form.SOLAL_ResponsavelQualificacao || 'Não informado'
					}
				],
				columns: 1
			});
		}

		dataTable.push({
			title: 'DESCRIÇÃO DA SOLICITAÇÃO',
			contents: [{ title: '', content: data.description }],
			columns: 1
		});

		dataTable.push({
			title: '',
			contents: [
				{ title: '', content: 'O requerente, profissional autônomo ou representante legal da empresa acima indicada, declara que:' },
				{ title: '1.', content: 'Todas as informações e documentos que instruem o presente processo de alvará de localização e funcionamento são a expressão da verdade, e que responderá civil e criminalmente, nos termos da legislação em vigor, por omissões e fatos controversos que venham a ser, posteriormente, apurados, isentando a Prefeitura Municipal de São Gonçalo do Amarante de quaisquer responsabilidades pelos mesmos, assumindo inclusive eventuais danos causados a terceiros;' },
				{ title: '2.', content: 'Está ciente de que a apuração de qualquer irregularidade implicará na cassação do alvará de localização e funcionamento, na interdição do estabelecimento e na aplicação de multas cabíveis, sem prejuízo das demais penalidades aplicáveis;' },
				{ title: '3.', content: 'Será responsável pelo presente termo, mesmo em caso de transferência do estabelecimento, até que sejam tomadas as providências para alteração do alvará de localização e funcionamento;' },
				{ title: '4.', content: 'A edificação em que se encontra instalada a atividade a ser licenciada possui laudo técnico, emitido por profissional habilitado, que atesta a eficiência do sistema de prevenção e combate a incêndio e pânico, instalado conforme legislação vigente;' },
				{ title: '5.', content: 'Está ciente de que o alvará de localização e funcionamento não dispensa o atendimento aos dispositivos legais de prevenção e combate a incêndio, junto ao Corpo de Bombeiros;' },
				{ title: '6.', content: 'Em caso de edificação condominial, responsabiliza-se pela instalação e pelo funcionamento da referida atividade nos termos da convenção do condomínio e do Código Civil;' },
				{ title: '7.', content: 'Está apto ao exercício da atividade ora requerida, nos termos da legislação que regulamenta a referida profissão, bem como está ciente de seus deveres e obrigações junto a conselhos e órgãos de classe, no caso de atividades vinculadas aos mesmos.' }
			],
			height: null,
			columns: 1,
			userOptions: {
				bodyStyles: {
					lineWidth: 0.5,
					fontSize: 8,
					cellPadding: 2,
					textColor: '#000000',
					font: 'Inter-SemiBold',
					fontStyle: 'normal',
				}
			}
		});
	
		this.generateLayoutAlvara(doc, data);

		return {
			pdfBase64: doc.output('datauristring').split(',')[1],
			pdfBuffer: doc.output('arraybuffer'),
			pdfFileName: this.global.user().PE_Nome
		};
	}

	public generateDocumentFormSemurb(data, headerForms: HeaderForms = HeaderForms.Semurb) {
        
        const doc = new jsPDF('p', 'mm', 'a4');
        doc.setFont("helvetica", "bold");

        this.renderHeaderSeplagAndSemurb(doc, headerForms);
        this.drawHorizontalLine(38, doc);
        doc.text("FORMULÁRIO DE REQUERIMENTO SEMURB", doc.internal.pageSize.width / 2 || doc.internal.pageSize.getWidth() / 2, 50, { align: 'center' });

        const subjectsHideSections = [
            'PESSOA JURÍDICA: CADASTRO TÉCNICO MUNICIPAL DE ATIVIDADES E INSTRUMENTOS DE DEFESA AMBIENTAL - CTM/AIDA',
            'PESSOA FÍSICA: CADASTRO TÉCNICO MUNICIPAL DE ATIVIDADES E INSTRUMENTOS DE DEFESA AMBIENTAL - CTM/AIDA',
			'APRESENTAÇÃO DE CONDICIONANTE DE LICENÇA/AUTORIZAÇÃO AMBIENTAL'
        ];

        const hideSections = subjectsHideSections.includes(data.subject);

        const atividade = getValuesActivity().find(a => a.value == data.form.atividade);
        const grupoAtividade = getValuesGroupActivity().find(g => g.value == data.form.grupoAtividade);

        let tableData: any[] = [
			{
                title: "DADOS DO SOLICITANTE",
                contents: [
                    { title: "SOLICITANTE: ", content: `${this.formatCpfCnpj(data.form.solicitante.cpfCnpj)} - ${data.form.solicitante.nomeRazao}` },
                    { title: "ENDEREÇO: ", content: `${data.form.solicitante.logradouro}, ${data.form.solicitante.numero}, ${data.form.solicitante.complemento}, ${data.form.solicitante.bairro}, ${data.form.solicitante.municipio} - ${data.form.solicitante.uf}, CEP: ${this.formatCEP(data.form.solicitante.cep)}` },
                    { title: "E-MAIL: ", content: data.form.solicitante.email },
                    { title: "TELEFONE: ", content: this.formatTelefone(data.form.solicitante.telefone) },
                ],
                columns: 1
            },
            {
                title: "DADOS DO REQUERENTE",
                contents: [
                    { title: "REQUERENTE: ", content: `${this.formatCpfCnpj(data.form.requerente.cpfCnpj)} - ${data.form.requerente.nomeRazao}` },
                    { title: "ENDEREÇO: ", content: `${data.form.requerente.logradouro}, ${data.form.requerente.numero}, ${data.form.requerente.complemento}, ${data.form.requerente.bairro}, ${data.form.requerente.municipio} - ${data.form.requerente.uf}, CEP: ${this.formatCEP(data.form.requerente.cep)}` },
                    { title: "E-MAIL: ", content: data.form.requerente.email },
                    { title: "TELEFONE: ", content: this.formatTelefone(data.form.requerente.telefone) },
                ],
                columns: 1
            },
            {
                title: "DADOS DA SOLICITAÇÃO",
                contents: [
                    { title: "ORGÃO: ", content: data.org },
                    { title: "ASSUNTO: ", content: data.subject },
                ],
                columns: 1
            },
        ];

		const detalhesContents = [
			...(data.form.SOL_Descricao ? [{ title: "DESCRIÇÃO: ", content: data.form.SOL_Descricao }] : []),
			...(data.form.tipoProcesso ? [{ title: "TIPO DO PROCESSO: ", content: data.form.tipoProcesso }] : []),
			...(data.form.modalidade ? [{ title: "MODALIDADE: ", content: data.form.modalidade }] : []),
			...(data.form.grupoAtividade ? [{
				title: "GRUPO DE ATIVIDADE: ",
				content: grupoAtividade ? `${grupoAtividade.value} - ${grupoAtividade.label}` : data.form.grupoAtividade
			}] : []),
			...(data.form.atividade ? [{
				title: "ATIVIDADE: ",
				content: atividade ? `${atividade.value} - ${atividade.label}` : data.form.atividade
			}] : []),
		];

        tableData.push({
            title: "DETALHES DA SOLICITAÇÃO",
            contents: detalhesContents,
            columns: 1
        });

        if (!hideSections) {
            tableData.push(
                {
                    title: 'DADOS DA ATIVIDADE/EMPREENDIMENTO',
                    contents: [
                        { title: 'NOME DO EMPREENDIMENTO: ', content: data.form.atividadeEmpreendimento?.nomeEmpreendimento },
                        {
                            title: 'ENDEREÇO COMPLETO: ',
                            content: data.form.atividadeEmpreendimento
                                ? `${data.form.atividadeEmpreendimento.logradouro}, ${data.form.atividadeEmpreendimento.numero}, ${data.form.atividadeEmpreendimento.complemento}, ${data.form.atividadeEmpreendimento.bairro}, ${data.form.atividadeEmpreendimento.municipio} - ${data.form.atividadeEmpreendimento.uf}, CEP: ${this.formatCEP(data.form.atividadeEmpreendimento.cep)}`
                                : ''
                        },
                        { title: 'ÁREA TOTAL CONSTRUÍDA: ', content: data.form.atividadeEmpreendimento?.areaConstruida ? data.form.atividadeEmpreendimento.areaConstruida + ' m²' : '' },
                        { title: 'Nº DE FUNCIONÁRIOS: ', content: data.form.atividadeEmpreendimento?.numeroFuncionarios },
                        { title: 'LICENÇA AMBIENTAL ANTERIOR: ', content: data.form.atividadeEmpreendimento?.licencaAnterior },
                        { title: 'NECESSITARÁ DE SUPRESSÃO VEGETAL: ', content: data.form.atividadeEmpreendimento?.supressaoVegetal },
                    ],
                    columns: 1
                },
                {
                    title: 'DADOS DO RESPONSÁVEL LEGAL PELO EMPREENDIMENTO',
                    contents: [
                        {
                            title: 'RESPONSÁVEL LEGAL: ',
                            content: data.form.responsavel?.cpf
                                ? `${this.formatCpfCnpj(data.form.responsavel.cpf)} - ${data.form.responsavel.nome}`
                                : ''
                        },
                        {
                            title: 'ENDEREÇO: ',
                            content: data.form.responsavel
                                ? `${data.form.responsavel.logradouro}, ${data.form.responsavel.numero}, ${data.form.responsavel.complemento}, ${data.form.responsavel.bairro}, ${data.form.responsavel.municipio} - ${data.form.responsavel.uf}, CEP: ${this.formatCEP(data.form.responsavel.cep)}`
                                : ''
                        },
                        { title: 'E-MAIL: ', content: data.form.responsavel?.email || '' },
                        { title: 'TELEFONE: ', content: data.form.responsavel?.telefone ? this.formatTelefone(data.form.responsavel.telefone) : '' },
                    ],
                    columns: 1
                }
            );
        }

		const consultoria = data.form.consultoria;

		const consultoriaContents = [
			...(consultoria?.cpfCnpj
				? [{
					title: 'RESPONSÁVEL LEGAL: ',
					content: `${this.formatCpfCnpj(consultoria.cpfCnpj)} - ${consultoria.nome}`
				}]
				: []),
		
			...(consultoria?.email
				? [{
					title: 'E-MAIL: ',
					content: consultoria.email
				}]
				: []),
		
			...(consultoria?.telefone
				? [{
					title: 'TELEFONE: ',
					content: this.formatTelefone(consultoria.telefone)
				}]
				: [])
		];
		
		if (consultoriaContents.length > 0) {
			tableData.push({
				title: 'DADOS DA CONSULTORIA',
				contents: consultoriaContents,
				columns: 1
			});
		}

		const infoComplementares = data.form.informacoesComplementares;

		const infoComplementaresContents = [
			...(infoComplementares?.tipologiaLicenca
				? [{
					title: 'TIPOLOGIA E Nº DA LICENÇA/AUTORIZAÇÃO AMBIENTAL: ',
					content: infoComplementares.tipologiaLicenca
				}]
				: []),

			...(infoComplementares?.processoVinculado
				? [{
					title: 'PROCESSO VINCULADO: ',
					content: infoComplementares.processoVinculado
				}]
				: [])
		];

		if (infoComplementaresContents.length > 0) {
			tableData.push({
				title: 'INFORMAÇÕES COMPLEMENTARES',
				contents: infoComplementaresContents,
				columns: 1
			});
		}

        tableData.push({
            title: '',
            contents: [
                {
                    title: '',
                    content: 'Declaro, para fins de direito, sob as penas da lei, que as informações acima prestadas e documentos são verdadeiros e autênticos. Atesto que estou ciente de que, se constatada falsidade ideológica ou documental responderei civil e criminalmente, na forma do art. 299 e seguinte código penal.'
                }
            ],
            columns: 1
        });

        this.generateTableSemurb(doc, tableData);
        this.renderFooter(doc);

		return {
			pdfBase64: doc.output('datauristring').split(',')[1],
			pdfBuffer: doc.output('arraybuffer'),
			pdfFileName: this.global.user().PE_Nome
		};
	}

	private getEspecieContribuinteLabel(value: string): string {
		const labels = {
			'EMPRESA': 'Empresa',
			'AUTONOMO': 'Autônomo',
			'SUBSTITUTO': 'Substituto',
			'EQUIPARADA': 'Equiparada a empresa',
			'RESPONSAVEL': 'Responsável',
			'OUTRO_MUNICIPIO': 'De outro município'
		};
		return labels[value] || value || 'Não informado';
	}

	private getTipoTributacaoLabel(value: string): string {
		const labels = {
			'RECEITA': 'Receita',
			'ESTIMATIVA': 'Estimativa',
			'PROFISSIONAL': 'Profissional',
			'PRIMARIO': 'Primário',
			'MEDIO': 'Médio',
			'SUPERIOR': 'Superior',
			'MOTORISTA': 'Motorista',
			'NENHUM': 'Nenhum'
		};
		return labels[value] || value || 'Não informado';
	}

	public formatCpfCnpj(cpfCnpj: string): string {
		if (!cpfCnpj) return '';

		const digitsOnly = cpfCnpj.replace(/\D/g, '');

		if (digitsOnly.length === 11) {
			return digitsOnly.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
		}

		if (digitsOnly.length === 14) {
			return digitsOnly.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
		}

		return cpfCnpj;
	}

	public formatTelefone(telefone: string): string {
		if (!telefone) return '';

		const digitsOnly = telefone.replace(/\D/g, '');

		if (digitsOnly.length === 11) {
			return digitsOnly.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
		}

		if (digitsOnly.length === 10) {
			return digitsOnly.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
		}

		return telefone;
	}

	public formatCEP(cep: string): string {
		if (!cep) return '';

		const digitsOnly = cep.replace(/\D/g, '');

		if (digitsOnly.length === 8) {
			return digitsOnly.replace(/^(\d{5})(\d{3})$/, '$1-$2');
		}

		return cep;
	}

	public formatInscricaoIPTU(inscricao: string) {
		const digitsOnly = inscricao.replace(/\D/g, '');

		return digitsOnly.replace(/^(\d{4})(\d{1})$/, '$1-$2');
	};

	public drawHorizontalLine(y, doc) {
		const lineWidth = doc.internal.pageSize.width - 20;
		const lineX = 10;
		doc.setLineWidth(0.5);
		doc.setDrawColor(0);
		doc.line(lineX, y, lineX + lineWidth, y);
	}

	public formatDate(dateString: string): string {
		if (!dateString) return dateString;

		const [year, month, day] = dateString.split('-');
		return `${day}/${month}/${year}`;
	}

}